// ==========================================
// FILTROS OUTLET - InicializaciÃ³n condicional
// ==========================================

(function() {
    const OUTLET_FILTERS_HTML = `<div id="outlet_positionfiltrosTopAllSite" class="">
        <div id="outlet_filtrosRef">
              <input type="search" name="q" required="" autocomplete="off" placeholder="Referencia" class="outlet_referencia outlet_form-field outlet_form-field--input">
        </div>
    <div id="outlet_filtrosTopAllSite">
        <div id="outlet_filtrosCategtorias">

        <div class="outlet_m-product-option outlet_m-product-option--dropdown"><select id="outlet_categoriasTopSelect" name="categoriasTopSelect" class="outlet_m-product-option--node"><option value="" class="outlet_m-product-option--node">Categoria</option><option value="blusas+blusa">BLUSAS</option><option value="faldas+falda">FALDAS</option><option value="pantalones+pantalon">PANTALONES</option><option value="vestidos+vestido">VESTIDOS</option><option value="vestidos-casuales+vestido-casual">- VESTIDOS CASUALES</option><option value="vestidos-casuales-cortos+vestido-casual-corto">- VESTIDOS CASUALES CORTOS</option><option value="conjuntos+conjunto">CONJUNTOS</option><option value="leggins+leggin">LEGGINS</option><option value="enterizos-y-overoles+enterizo-y-overol">ENTERIZOS Y OVEROLES</option><option value="shorts+short">SHORTS</option><option value="chaquetas+chaqueta">CHAQUETAS</option></select></div></div>
        <div id="outlet_filtrosTallas" class="none">
            <div class="outlet_m-product-option outlet_m-product-option--dropdown">
                <select id="outlet_tallasTopSelect" name="tallasTopSelect">
                    <option value="" class="outlet_m-product-option--node">Talla</option>
                    <option value="XS6" class="outlet_m-product-option--node">XS(6)</option>
                    <option value="S8" class="outlet_m-product-option--node">S(8)</option>
                    <option value="M10" class="outlet_m-product-option--node">M(10)</option>
                    <option value="L12" class="outlet_m-product-option--node">L(12)</option>
                    <option value="XL14" class="outlet_m-product-option--node">XL(14)</option>
                    <option value="XXL16" class="outlet_m-product-option--node">XXL(16)</option>
                    <option value="XXXL18" class="outlet_m-product-option--node">XXXL(18)</option>
                </select>
            </div>
        </div>
        <div id="outlet_filtrosColores" class="none">
            <div class="outlet_m-product-option outlet_m-product-option--dropdown">
                <select id="outlet_colorTopSelect" name="colorTopSelect">
                    <option value="" class="outlet_m-product-option--node">Color</option>
                    <option value="camel">CAMEL</option>
                    <option value="coral">CORAL</option>
                    <option value="fucsia">FUCSIA</option>
                    <option value="marfil">MARFIL</option>
                    <option value="negro">NEGRO</option>
                    <option value="verde">VERDE</option>
                    <option value="vinotinto">VINOTINTO</option>
                    <option value="morado">MORADO</option>
                    <option value="cafe">CAFE</option>
                    <option value="azul">AZUL</option>
                    <option value="rojo">ROJO</option>
                    <option value="blanco">BLANCO</option>
                    <option value="rosa">ROSA</option>
                    <option value="multicolor">MULTICOLOR</option>
                    <option value="palo-de-rosa">PALO DE ROSA</option>
                    <option value="crema">CREMA</option>
                    <option value="guayaba">GUAYABA</option>
                    <option value="ocre">OCRE</option>
                    <option value="mora">MORA</option>
                    <option value="oro-rosa">ORO ROSA</option>
                    <option value="confite">CONFITE</option>
                    <option value="piton">PITON</option>
                    <option value="camuflado">CAMUFLADO</option>
                    <option value="miel">MIEL</option>
                    <option value="cuadros">CUADROS</option>
                    <option value="terracota">TERRACOTA</option>
                    <option value="lila">LILA</option>
                    <option value="amarillo">AMARILLO</option>
                    <option value="dorado">DORADO</option>
                    <option value="gris">GRIS</option>
                    <option value="mostaza">MOSTAZA</option>
                    <option value="plata">PLATA</option>
                    <option value="rosado">ROSADO</option>
                    <option value="mandarina">MANDARINA</option>
                    <option value="animal-print">ANIMAL PRINT</option>
                    <option value="beige">BEIGE</option>
                    <option value="naranja">NARANJA</option>
                </select>
            </div>
        </div>
    </div>
    <div id="outlet_btnEncuentraTuTalla">
            <a id="outlet_encuentraTutalla" href="https://xcesomayoristas.com/collections/outlet" class="outlet_m:w-full outlet_m-button outlet_m-button--primary">Buscar</a>
    </div>
</div>`;

    function isOutletPage() {
        // Verificar si estamos en una pÃ¡gina de outlet
        return document.body && document.body.classList.contains('catalogo-outlet');
    }

    function hideOriginalFilters() {
        // Ocultar el filtro original cuando estamos en outlet
        const originalFilters = document.querySelector('#positionfiltrosTopAllSite');
        if (originalFilters) {
            originalFilters.style.display = 'none';
            console.log('[OUTLET] Filtros originales ocultados');
        }
    }

    function createOutletFilters() {
        // Verificar si ya existen los filtros de outlet
        if (document.querySelector('#outlet_positionfiltrosTopAllSite')) {
            console.log('[OUTLET] Filtros de outlet ya existen');
            return;
        }

        // Encontrar dÃ³nde insertar los filtros (antes del filtro original)
        const originalFilters = document.querySelector('#positionfiltrosTopAllSite');
        if (!originalFilters || !originalFilters.parentNode) {
            console.warn('[OUTLET] No se encontrÃ³ el contenedor de filtros original');
            return;
        }

        // Crear un contenedor temporal para parsear el HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = OUTLET_FILTERS_HTML;

        // Insertar los nuevos filtros antes del filtro original
        const outletFiltersContainer = tempDiv.firstElementChild;
        originalFilters.parentNode.insertBefore(outletFiltersContainer, originalFilters);

        console.log('[OUTLET] Filtros de outlet creados exitosamente');

        // Configurar los event listeners para los filtros de outlet
        setupOutletFilterListeners();
    }

    function setupOutletFilterListeners() {
        const elements = {
            reference: document.querySelector('#outlet_filtrosRef input[name="q"]'),
            category: document.querySelector('#outlet_categoriasTopSelect'),
            size: document.querySelector('#outlet_tallasTopSelect'),
            color: document.querySelector('#outlet_colorTopSelect'),
            button: document.querySelector('#outlet_encuentraTutalla')
        };

        if (!elements.button) {
            console.warn('[OUTLET] No se encontrÃ³ el botÃ³n de bÃºsqueda');
            return;
        }

        // Event listeners para los selectores
        ['category', 'size', 'color'].forEach(filter => {
            elements[filter]?.addEventListener('change', () => {
                updateOutletURL(elements);
            });
        });

        // Event listener para el botÃ³n de bÃºsqueda con Enter
        const allInputs = document.querySelectorAll('#outlet_positionfiltrosTopAllSite select');
        allInputs.forEach(input => {
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    elements.button.click();
                }
            });
        });

        // Forzar navegaciÃ³n en el click del botÃ³n
        elements.button.addEventListener('click', (e) => {
            const href = elements.button.getAttribute('href')?.trim();
            if (!href) {
                e.preventDefault();
                console.warn('[OUTLET] href vacÃ­o o invÃ¡lido');
                return;
            }

            e.preventDefault();
            try {
                const finalURL = new URL(href, window.location.origin).toString();
                console.debug('[OUTLET] Navegando a:', finalURL);
                window.location.assign(finalURL);
            } catch (err) {
                console.error('[OUTLET] URL invÃ¡lida:', href, err);
            }
        }, { passive: false });

        // Inicializar URL
        updateOutletURL(elements);
    }

    function updateOutletURL(elements) {
        // Obtener valores de los filtros
        const categoryVal = (elements.category?.value || '').trim();
        const sizeVal = (elements.size?.value || '').trim();
        const colorVal = (elements.color?.value || '').trim();

        // Construir la URL base
        let url = 'https://xcesomayoristas.com/collections/outlet';

        // Array para construir la ruta
        const pathParts = [];

        // Agregar categorÃ­a si existe
        if (categoryVal) {
            pathParts.push(categoryVal);
        }

        // Agregar talla si existe
        if (sizeVal) {
            pathParts.push(sizeVal);
        }

        // Agregar color si existe
        if (colorVal) {
            pathParts.push(colorVal);
        }

        // Si hay algÃºn filtro seleccionado, construir la URL
        if (pathParts.length > 0) {
            url += '/' + pathParts.join('+');
        }

        // Actualizar el href del botÃ³n
        elements.button.setAttribute('href', url);

        console.debug('[OUTLET] URL actualizada:', url);
    }

    function initializeOutletFilters() {
        if (!isOutletPage()) {
            console.log('[OUTLET] No estamos en pÃ¡gina de outlet, filtros outlet no se cargarÃ¡n');
            return;
        }

        console.log('[OUTLET] Inicializando filtros de outlet...');

        // Ocultar filtros originales
        hideOriginalFilters();

        // Crear y mostrar filtros de outlet
        createOutletFilters();
    }

    // Ejecutar cuando el DOM estÃ© listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeOutletFilters);
    } else {
        // DOM ya estÃ¡ listo
        initializeOutletFilters();
    }

    // TambiÃ©n verificar despuÃ©s de un delay por si el body.class se agrega despuÃ©s
    setTimeout(initializeOutletFilters, 500);
})();